// import React, { useEffect, useState } from "react";
// import axios from "axios";

// function App() {
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const config = {
//           method: "get",
//           maxBodyLength: Infinity,
//             //url: 'https://dsposbackend.dockyardsoftware.com/Warehouse/GetWHList',
//              url: 'https://dsposbackend.dockyardsoftware.com/AddGRN/AddGrn',
//             //  url: 'http://localhost:51976/ICTDevice/GetComLocation?catcode=1',
//               //  url: 'http://localhost:51324/HelpDesk/GetAllTickets',

//                headers: {
//             "auth-key": "xYBFBOj9UcL9jZ3xf6L9gEfkOHmYA2VaPD5rH6kAU9g=",
//           },
//         };

//         const response = await axios.request(config);
//         setData(response.data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   return (
//     <div style={{ padding: "20px" }}>
//       <h1>Computer Details</h1>
//       <pre>{data ? JSON.stringify(data, null, 2) : "Loading..."}</pre>
//     </div>
//   );
// }

// export default App;
// import React, { useEffect, useState } from "react";
// import axios from "axios";

// function App() {
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const payload = [
//           {
//             P_WHCODE: "B01",
//             P_SUPCODE: "2",
//             P_INNO: "100",
//             P_INDATE: "2025-11-22",
//             P_PDATE: "2025-11-22",
//             Items: [
//               {
//                 P_PRCODE: 6,
//                 P_QTY: 10.5,
//                 P_VALUE: 1050,
//                 P_AVERATE: 100,
//                 P_BLQTY: 10.5,
//                 P_EXDATE: "2026-12-31",
//                 P_PPRICE: 95,
//                 P_MPRICE: 120,
//                 P_SPRICE: 110,
//               },
//               {
//                 P_PRCODE: 3,
//                 P_QTY: 5,
//                 P_VALUE: 2500,
//                 P_AVERATE: 500,
//                 P_BLQTY: 5,
//                 P_EXDATE: "2027-06-30",
//                 P_PPRICE: 480,
//                 P_MPRICE: 550,
//                 P_SPRICE: 520,
//               },
//             ],
//           },
//         ];

//         const config = {
//           method: "post",
//           url: "https://dsposbackend.dockyardsoftware.com/AddGRN/AddGrn",
//           headers: {
//             "auth-key": "xYBFBOj9UcL9jZ3xf6L9gEfkOHmYA2VaPD5rH6kAU9g=",
//             "Content-Type": "application/json",
//           },
//           data: payload,
//         };

//         const response = await axios.request(config);
//         setData(response.data);
//       } catch (error) {
//         console.error("Error posting data:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   return (
//     <div style={{ padding: "20px" }}>
//       <h1>GRN API Response</h1>
//       <pre>{data ? JSON.stringify(data, null, 2) : "Submitting..."}</pre>
//     </div>
//   );
// }

// export default App;

// src/App.js
import React, { useEffect, useState } from "react";

function App() {
  const [publicIp, setPublicIp] = useState("Loading...");
  const [localIps, setLocalIps] = useState([]);
  const [providedHostname, setProvidedHostname] = useState("");
  const [note, setNote] = useState("");

  useEffect(() => {
    // 1) get public IP via ipify
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setPublicIp(data.ip))
      .catch(() => setPublicIp("Unavailable"));

    // 2) get local/private IPs via WebRTC (best-effort)
    // Note: modern browsers may restrict this; it might return nothing.
    const ips = new Set();

    // Compatibility for RTCPeerConnection
    const RTCPeerConnection =
      window.RTCPeerConnection ||
      window.mozRTCPeerConnection ||
      window.webkitRTCPeerConnection;

    if (!RTCPeerConnection) {
      setNote("WebRTC not supported by this browser — cannot get local IPs.");
      return;
    }

    const pc = new RTCPeerConnection({ iceServers: [] });

    // create a bogus data channel (some browsers need this)
    try {
      pc.createDataChannel("dummy");
    } catch (e) {
      // ignore
    }

    pc.onicecandidate = (event) => {
      if (!event || !event.candidate) {
        // ICE gathering finished
        pc.close();
        if (ips.size === 0) {
          setNote(
            "No local IP discovered — browser/network likely blocks WebRTC local IP exposure."
          );
        }
        setLocalIps(Array.from(ips));
        return;
      }

      const candidate = event.candidate.candidate;
      // candidate string contains IPs — extract them
      const ipRegex =
        /([0-9]{1,3}(\.[0-9]{1,3}){3})|([a-fA-F0-9:]{3,})/g; // IPv4 or IPv6 fallback
      const matches = candidate.match(ipRegex) || [];
      matches.forEach((ip) => {
        // filter out non-private if you only want private IPs you can add filter
        ips.add(ip);
      });
    };

    pc.createOffer()
      .then((offer) => pc.setLocalDescription(offer))
      .catch(() => {
        setNote("Unable to create WebRTC offer.");
        pc.close();
      });

    // safety timeout: close after 3s if not finished
    const t = setTimeout(() => {
      if (pc.iceGatheringState !== "complete") {
        try {
          pc.close();
        } catch (e) {}
        setLocalIps(Array.from(ips));
        if (ips.size === 0)
          setNote(
            "Local IP lookup timed out or was blocked. Try different browser or check Privacy settings."
          );
      }
    }, 3000);

    return () => {
      clearTimeout(t);
      try {
        pc.close();
      } catch (e) {}
    };
  }, []);

  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: 20 }}>
      <h2>IP & Device Info (Frontend-only)</h2>

      <div style={{ marginBottom: 12 }}>
        <strong>Public IP:</strong>
        <div style={{ marginTop: 6 }}>{publicIp}</div>
      </div>

      <div style={{ marginBottom: 12 }}>
        <strong>Local / Private IPs (best-effort):</strong>
        <div style={{ marginTop: 6 }}>
          {localIps.length > 0 ? (
            <ul>
              {localIps.map((ip) => (
                <li key={ip}>{ip}</li>
              ))}
            </ul>
          ) : (
            <div>None discovered (may be blocked by browser/network)</div>
          )}
        </div>
      </div>

      <div style={{ marginBottom: 12 }}>
        <strong>Hostname (user-provided):</strong>
        <div style={{ marginTop: 6 }}>
          <input
            placeholder="Type or paste your machine name here"
            value={providedHostname}
            onChange={(e) => setProvidedHostname(e.target.value)}
            style={{ padding: 8, width: "100%", maxWidth: 400 }}
          />
          <div style={{ marginTop: 6, color: "#666" }}>
            Browsers do not expose the machine hostname. You can type/paste it
            here or follow the small instructions below to copy it automatically.
          </div>
        </div>
      </div>

      {note && (
        <div style={{ marginTop: 10, color: "darkorange" }}>
          <strong>Note:</strong> {note}
        </div>
      )}

      <hr style={{ marginTop: 18, marginBottom: 18 }} />

      <div>
        <h4>Quick local commands to copy machine name to clipboard</h4>
        <p>
          Run one of these on your machine, then paste into the Hostname box above:
        </p>
        <ul>
          <li>
            <strong>Windows (cmd):</strong>{" "}
            <code>echo %COMPUTERNAME% | clip</code> — then paste (clipboard now has hostname)
          </li>
          <li>
            <strong>Windows (PowerShell):</strong>{" "}
            <code>Write-Output $env:COMPUTERNAME | clip</code>
          </li>
          <li>
            <strong>macOS:</strong> <code>scutil --get ComputerName | pbcopy</code>
          </li>
          <li>
            <strong>Linux (GNOME):</strong> <code>hostname | xsel --clipboard</code> (or copy manually)
          </li>
        </ul>
        <div style={{ color: "#666" }}>
          These commands copy the hostname to your clipboard so you can paste it into the page.
        </div>
      </div>
    </div>
  );
}

export default App;
